/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type models_OrganizationMetadataPropertyCreateRequest = {
    default_value?: any;
    description?: string;
    key: string;
    label: string;
    options?: Array<string>;
    required?: boolean;
    type: models_OrganizationMetadataPropertyCreateRequest.type;
};
export namespace models_OrganizationMetadataPropertyCreateRequest {
    export enum type {
        STRING = 'string',
        NUMBER = 'number',
        BOOLEAN = 'boolean',
        SELECT = 'select',
    }
}

